import type { FieldErrors, FieldValues } from 'react-hook-form';

/**
 * Extrai a primeira mensagem de erro legível de um FieldErrors do RHF
 * (recursivo — cobre arrays/objetos aninhados tipo entitlements[0].slug).
 *
 * Uso: handler `onInvalid` do handleSubmit. Garante que validação que falha
 * SEMPRE gera feedback — sem isso o submit morre silencioso e o usuário acha
 * que o botão está quebrado.
 */
export function firstErrorMessage<T extends FieldValues>(
  errors: FieldErrors<T> | undefined,
): string | null {
  if (!errors) return null;
  return walk(errors);
}

function walk(node: unknown): string | null {
  if (!node || typeof node !== 'object') return null;
  const rec = node as Record<string, unknown>;

  if (typeof rec.message === 'string' && rec.message.length > 0) {
    return rec.message;
  }

  for (const value of Object.values(rec)) {
    if (Array.isArray(value)) {
      for (const item of value) {
        const found = walk(item);
        if (found) return found;
      }
    } else if (value && typeof value === 'object') {
      const found = walk(value);
      if (found) return found;
    }
  }
  return null;
}
